export { default } from './RegistrasiMerchant';
